<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name(:class="{ 'non-active-font': !active }") 利用者ごとの予約制限の確認対象
        span.validation-label(v-if="active") 必須
      .right-side
        slot(name="question")

    .register-value.reservation-limit-type-radios(:class="[ { 'non-active': !active } ]")
      label.register-radio-label
        input#reservation-limit-type-0.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="利用者ごとの予約制限の確認対象"
          :disabled="!active")
        span.register-radio-text 訪問面会およびオンライン面会
      label.register-radio-label
        input#reservation-limit-type-1.register-radio-form(v-model="_value" :name="name" type="radio" :value="1" :disabled="!active")
        span.register-radio-text {{ _reservationTypeName }}のみ

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { ReservationType } from "@/commons/services/Reservations";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputReservationLimitType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  value!: number;

  /** 活性にするか否か */
  @Prop({ default: true })
  active!: boolean;

  /** 面会種別 */
  @Prop()
  reservationType!: ReservationType;

  @Prop({ default: "limit-type" })
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }

  /** 面会種別名を取得する */
  get _reservationTypeName(): string {
    if (this.reservationType == ReservationType.VISIT) {
      return "訪問面会";
    } else if (this.reservationType == ReservationType.ONLINE) {
      return "オンライン面会";
    } else {
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

// ラジオボタンは横幅に応じてラップする
.reservation-limit-type-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}

.reservation-limit-type-radios.non-active {
  .register-radio-text {
    color: $btn-font-disable !important;
    cursor: not-allowed !important;

    &:hover {
      background: $bg-default !important;
    }
  }
  .register-radio-form:checked + .register-radio-text {
    background: $btn-disable !important;
    color: $btn-font-disable !important;
    border: 1px solid $btn-disable !important;
  }
}
.non-active-font {
  color: $form-border-color;
}
</style>
